module.exports = __webpack_public_path__ + "static/phoneLightClear-a6eb917e354c7f8de628899d5757bf69.png";